"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userDataResponseValidator = void 0;
var tslib_1 = require("tslib");
var models_1 = require("../models");
var response_reporter_1 = require("./response-reporter/response-reporter");
var error = {
    errorCode: models_1.ErrorCode.InvalidUserDataResponse,
    developerMessage: "Invalid User Data",
    userMessageTitle: "Something went wrong",
    userMessageBody: "Please try again later.",
};
var validateResponse = function (_a) {
    var validationCallback = _a.validationCallback, response = _a.response, reportingData = _a.reportingData;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!validationCallback()) return [3 /*break*/, 2];
                    return [4 /*yield*/, response_reporter_1.responseReporter.report(reportingData)];
                case 1:
                    _b.sent();
                    return [2 /*return*/, Promise.reject(error)];
                case 2: return [2 /*return*/, response];
            }
        });
    });
};
exports.userDataResponseValidator = {
    validateResponse: validateResponse,
};
